import type { FC } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';

interface Props {
	label: string;
	onLight?: boolean;
	onPress: () => void;
}

const CardLinkAction: FC<Props> = ({ label, onLight = false, onPress }) => (
	<View>
		<View style={[styles.divider, onLight ? styles.dividerOnLight : null]} />
		<Pressable accessibilityRole="button" style={styles.row} onPress={onPress}>
			<Text style={[styles.label, onLight ? styles.labelOnLight : null]}>{label}</Text>
			<SvgIcon
				name={SvgIconType.chevronRight}
				size={Dimens.iconSize10}
				tintColor={onLight ? Colors.green700 : Colors.white}
			/>
		</Pressable>
	</View>
);

const styles = StyleSheet.create({
	divider: {
		height: Dimens.size1,
		backgroundColor: Colors.white33,
	},
	dividerOnLight: {
		backgroundColor: Colors.gray300,
	},
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: Dimens.gap12,
		paddingTop: Dimens.padding16,
	},
	label: {
		flex: Dimens.flex1,
		color: Colors.white,
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize14,
		lineHeight: Dimens.lineHeight20,
	},
	labelOnLight: {
		color: Colors.green700,
		fontFamily: Fonts.barlowMedium,
	},
});

export default CardLinkAction;
